// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__8pLHO","show-spinner":"loader_show-spinner__A4Atg"};